import { TextField } from "@mui/material";

const TextInput = ({
  onChange = (e: string) => {},
  errorState = { state: false, msg: "" },
  ...args
}) => {
  return (
    <TextField
      color="warning"
      variant="outlined"
      className="flex bg-white border-none outline-none"
      error={errorState.state}
      helperText={errorState.msg.length !== 0 ? errorState.msg : null}
      onChange={function (value) {
        onChange(value.currentTarget.value);
      }}
      {...args}
    />
  );
};

export default TextInput;
